"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.step1ErrorsLens = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/customer/wizard");
//#region INITIALSTATE
exports.initialState = {
    customerId: null,
    customerUuid: null,
    customerName: null,
    businessId: null,
    fetchingCustomer: 'STANDBY',
    saveCustomer: 'STANDBY',
    saveError: undefined,
    wizardStep: 0,
    fetchingSelectedCompany: 'STANDBY',
    fetchingContractFiles: 'STANDBY',
    uploadingContractFiles: 'STANDBY',
    uploadedItems: {},
    step1: {
        status: 'INITIAL',
        companyName: '',
        businessId: '',
        hasBusinessId: true,
        street: '',
        postalCode: '',
        city: '',
        country: '',
        state: '',
        salesman: null,
        features: [],
        featuresStatus: 'STANDBY',
        featuresError: undefined,
        contractFiles: [],
        companyLogo: {},
        files: [],
        client: true
    }
};
//#endregion
//#region LENS
const customerIdLens = monocle.Lens.fromProp('customerId');
const customerUuidLens = monocle.Lens.fromProp('customerUuid');
const customerNameLens = monocle.Lens.fromProp('customerName');
const businessIdLens = monocle.Lens.fromProp('businessId');
const fetchingCustomerLens = monocle.Lens.fromProp('fetchingCustomer');
const saveCustomerLens = monocle.Lens.fromProp('saveCustomer');
const saveErrorLens = monocle.Lens.fromProp('saveError');
const fetchingContractFilesLens = monocle.Lens.fromProp('fetchingContractFiles');
const uploadingContractFilesLens = monocle.Lens.fromProp('uploadingContractFiles');
const uploadedItemsLens = monocle.Lens.fromProp('uploadedItems');
const stepLens = monocle.Lens.fromProp('wizardStep');
const fetchingSelectedCompanyLens = monocle.Lens.fromProp('fetchingSelectedCompany');
const step1ValueLens = monocle.Lens.fromPath(['step1']);
const contractFilesLens = monocle.Lens.fromPath(['step1', 'contractFiles']);
const updateFieldLens = (key) => monocle.Lens.fromProp(key);
// ERRORS
const step1ErrorStatusLens = monocle.Lens.fromProp('status');
exports.step1ErrorsLens = new monocle.Optional((v) => v.status === 'ERROR' ? fp.option.some(v.errors) : fp.option.none, (errors) => (v) => {
    if (v.status === 'ERROR')
        return Object.assign(Object.assign({}, v), { errors });
    return v;
});
const featuresStatusLens = monocle.Lens.fromProp('featuresStatus');
const featuresLens = monocle.Lens.fromProp('features');
const featuresErrorLens = monocle.Lens.fromProp('featuresError');
const methods = {};
exports.methods = methods;
methods[Actions.UPDATE_FIELD] = (state, action) => {
    return fp.function.compose(step1ValueLens.modify(updateFieldLens(action.payload.key).set(action.payload.value)), step1ValueLens
        .asOptional()
        .compose(exports.step1ErrorsLens)
        .modify((x) => {
        delete x[action.payload.key];
        return x;
    }))(state);
};
methods[Actions.SET_COMPANY_LOGO] = (state, action) => step1ValueLens.modify(updateFieldLens('companyLogo').set(action.payload))(state);
methods[Actions.SET_FILES] = (state, action) => step1ValueLens.modify(updateFieldLens('files').set(action.payload))(state);
methods[Actions.REMOVE_FILE] = (state, action) => step1ValueLens.modify(updateFieldLens('files').modify((files) => files.filter(({ uuid }) => uuid !== action.payload.uuid)))(state);
methods[Actions.TOGGLE_CLIENT] = (state) => step1ValueLens.modify(updateFieldLens('client').modify((current) => !current))(state);
methods[Actions.SET_YTJ_COMPANY_REQUEST] = (state) => fetchingSelectedCompanyLens.set('FETCHING')(state);
methods[Actions.SET_YTJ_COMPANY_SUCCESS] = (state, action) => {
    return fp.function.compose(fetchingSelectedCompanyLens.set('STANDBY'), step1ValueLens.modify(fp.function.compose(updateFieldLens('companyName').set(action.payload.name), updateFieldLens('businessId').set(action.payload.businessId || ''), updateFieldLens('hasBusinessId').set(!!action.payload.businessId), (step1) => {
        if (action.payload.addressDetails) {
            return fp.function.compose(updateFieldLens('street').set(action.payload.addressDetails.street), updateFieldLens('postalCode').set(action.payload.addressDetails.postalCode), updateFieldLens('city').set(action.payload.addressDetails.city), updateFieldLens('country').set(action.payload.addressDetails.country.toUpperCase()))(step1);
        }
        return step1;
    })))(state);
};
methods[Actions.SET_YTJ_COMPANY_FAILURE] = (state) => fetchingSelectedCompanyLens.set('FAILURE')(state);
methods[Actions.VALIDATE_STEP_FAILURE] = (state, action) => fp.function.compose(step1ValueLens
    .asOptional()
    .compose(exports.step1ErrorsLens)
    .set(action.payload.errors.reduce((rv, x) => {
    ;
    (rv[x.key] = rv[x.key] || []).push(x.value);
    return rv;
}, {})), step1ValueLens.compose(step1ErrorStatusLens).set('ERROR'), saveCustomerLens.set('FAILURE'))(state);
methods[Actions.VALIDATE_STEP_SUCCESS] = (state, action) => fp.function.compose(stepLens.set(action.payload.wizardStep), saveCustomerLens.set('STANDBY'), step1ValueLens.compose(step1ErrorStatusLens).set('INITIAL'), step1ValueLens.asOptional().compose(exports.step1ErrorsLens).set({}))(state);
methods[Actions.CLEAR_STATE] = () => (Object.assign({}, exports.initialState));
// fetch customer
methods[Actions.FETCH_CUSTOMER_REQUEST] = (state, action) => fp.function.compose(fetchingCustomerLens.set('FETCHING'), step1ValueLens.compose(step1ErrorStatusLens).set('INITIAL'), step1ValueLens.asOptional().compose(exports.step1ErrorsLens).set({}))(state);
methods[Actions.FETCH_CUSTOMER_SUCCESS] = (state, action) => fp.function.compose(customerIdLens.set(action.payload.id), customerUuidLens.set(action.payload.uuid), customerNameLens.set(action.payload.name), businessIdLens.set(action.payload.businessId), step1ValueLens.modify((data) => {
    const { name, businessId, addressDetails, salesRepresentative } = action.payload;
    return Object.assign(Object.assign({}, data), { companyName: name, businessId: businessId, street: (addressDetails && addressDetails.street) || '', postalCode: (addressDetails && addressDetails.postalCode) || '', city: (addressDetails && addressDetails.city) || '', state: (addressDetails && addressDetails.state) || '', country: (addressDetails && addressDetails.country) || '', salesman: salesRepresentative !== null ? salesRepresentative.id : null, client: action.payload.client, hasBusinessId: !!businessId });
}), fetchingCustomerLens.set('FETCHED'))(state);
methods[Actions.FETCH_CUSTOMER_FAILURE] = (state, action) => fetchingCustomerLens.set('FAILURE')(state);
// save customer
methods[Actions.SAVE_CUSTOMER_REQUEST] = (state) => fp.function.compose(step1ValueLens.compose(step1ErrorStatusLens).set('INITIAL'), saveCustomerLens.set('SAVING'))(state);
methods[Actions.SAVE_CUSTOMER_SUCCESS] = (state, action) => fp.function.compose(customerIdLens.set(action.payload.id), customerUuidLens.set(action.payload.uuid), customerNameLens.set(action.payload.name), businessIdLens.set(action.payload.businessId), saveCustomerLens.set('SAVED'))(state);
methods[Actions.SAVE_CUSTOMER_FAILURE] = (state, action) => fp.function.compose(saveCustomerLens.set('FAILURE'), saveErrorLens.set(action.payload))(state);
// fetch contract files
methods[Actions.FETCH_CONTRACT_FILES_REQUEST] = (state, action) => fetchingContractFilesLens.set('FETCHING')(state);
methods[Actions.FETCH_CONTRACT_FILES_SUCCESS] = (state, action) => fp.function.compose(fetchingContractFilesLens.set('FETCHED'), contractFilesLens.set(action.payload))(state);
methods[Actions.FETCH_CONTRACT_FILES_FAILURE] = (state, action) => fetchingContractFilesLens.set('FAILURE')(state);
// upload contract files
methods[Actions.UPLOAD_CONTRACT_FILE_REQUEST] = (state, action) => fp.function.compose(uploadedItemsLens.modify((x) => action.payload.files.reduce((r, file) => {
    r[file.uuid] = {
        status: 'UPLOADING',
        error: undefined,
        uploaded: 0
    };
    return r;
}, Object.assign({}, x))), uploadingContractFilesLens.set('UPLOADING'))(state);
methods[Actions.UPLOAD_CONTRACT_FILE_STATUS] = (state, action) => uploadedItemsLens.modify((x) => {
    const clone = Object.assign({}, x);
    clone[action.payload.uuid] = Object.assign(Object.assign({}, x[action.payload.uuid]), { uploaded: action.payload.uploaded });
    return clone;
})(state);
methods[Actions.UPLOAD_CONTRACT_FILE_SUCCESS] = (state, action) => fp.function.compose((x) => {
    const isUploading = Object.values(x.uploadedItems).find(({ status }) => status === 'UPLOADING');
    const hasFailure = Object.values(x.uploadedItems).find(({ status }) => status === 'FAILURE');
    return fp.function.compose(isUploading || hasFailure
        ? (x) => x
        : step1ValueLens.modify(updateFieldLens('files').set([])), isUploading || hasFailure
        ? (x) => x
        : uploadedItemsLens.set({}), uploadingContractFilesLens.set(isUploading ? 'UPLOADING' : hasFailure ? 'FAILURE' : 'UPLOADED'))(x);
}, uploadedItemsLens.modify((x) => {
    const clone = Object.assign({}, x);
    clone[action.payload] = Object.assign(Object.assign({}, x[action.payload]), { status: 'UPLOADED' });
    return clone;
}))(state);
methods[Actions.UPLOAD_CONTRACT_FILE_FAILURE] = (state, action) => fp.function.compose((x) => {
    const isUploading = Object.values(x.uploadedItems).find(({ status }) => status === 'UPLOADING');
    const hasFailure = Object.values(x.uploadedItems).find(({ status }) => status === 'FAILURE');
    return fp.function.compose(isUploading || hasFailure
        ? (x) => x
        : step1ValueLens.modify(updateFieldLens('files').set([])), isUploading || hasFailure
        ? (x) => x
        : uploadedItemsLens.set({}), uploadingContractFilesLens.set(isUploading ? 'UPLOADING' : hasFailure ? 'FAILURE' : 'UPLOADED'))(x);
}, uploadedItemsLens.modify((x) => {
    const clone = Object.assign({}, x);
    clone[action.payload.uuid] = Object.assign(Object.assign({}, x[action.payload.uuid]), { status: 'FAILURE', error: action.payload.error });
    return clone;
}))(state);
//#endregion
methods[Actions.SELECT] = (state, action) => {
    return step1ValueLens.modify(featuresLens.modify((items) => items.map((x) => {
        if (x.uuid === action.payload.feature.uuid) {
            return Object.assign(Object.assign({}, x), { enabled: true });
        }
        return x;
    })))(state);
};
methods[Actions.UNSELECT] = (state, action) => {
    return step1ValueLens.modify(featuresLens.modify((items) => items.map((x) => {
        if (x.uuid === action.payload.feature.uuid) {
            return Object.assign(Object.assign({}, x), { enabled: false });
        }
        return x;
    })))(state);
};
methods[Actions.UPDATE_PRICE] = (state, action) => {
    return step1ValueLens.modify(featuresLens.modify((items) => items.map((x) => {
        if (x.uuid === action.payload.uuid) {
            return Object.assign(Object.assign({}, x), { price: action.payload.price });
        }
        return x;
    })))(state);
};
methods[Actions.COPY_ALL] = (state, action) => {
    return step1ValueLens.modify(fp.function.compose(featuresStatusLens.set('FETCHED'), featuresLens.set(action.payload.features)))(state);
};
methods[Actions.FETCH_FEATURES_REQUEST] = (state) => step1ValueLens.modify(fp.function.compose(featuresErrorLens.set(undefined), featuresLens.set([]), featuresStatusLens.set('FETCHING')))(state);
methods[Actions.FETCH_FEATURES_SUCCESS] = (state, action) => step1ValueLens.modify(fp.function.compose(featuresStatusLens.set('FETCHED'), featuresLens.set(action.payload.features)))(state);
methods[Actions.FETCH_FEATURES_FAILED] = (state, action) => step1ValueLens.modify(fp.function.compose(featuresLens.set([]), featuresStatusLens.set('FAILED'), featuresErrorLens.set(action.payload.error)))(state);
//# sourceMappingURL=wizard.js.map